import { useEffect, useState } from "react";

const useToolId = Id => {
    const [toolId, setToolId] = useState({});

    useEffect(() => {
        const url = `https://agile-brook-59909.herokuapp.com/tools/${Id}`;
        // console.log(url)
        fetch(url)
            .then(res => res.json())
            .then(data => setToolId(data));
    }, [Id]);
    return [toolId, setToolId]
}
export default useToolId;